/**
 * PDF-safe formatting (jsPDF default fonts do not render ₹ or some Unicode well).
 */

export function formatAmountForPdf(value: number): string {
  const n = Number(value);
  if (Number.isNaN(n)) {
    return 'INR 0.00';
  }
  return `INR ${n.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDateForPdf(iso?: string | null): string {
  if (!iso) {
    return '-';
  }
  const d = new Date(iso.includes('T') ? iso : `${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) {
    return String(iso);
  }
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
